export default {
  header: 'Angeheftete Apps',
  subheader: 'Ziehen Sie die Apps, die in der Navigationsleiste erscheinen sollen, in die Liste der angehefteten Apps und ordnen Sie sie in der Reihenfolge an, in der sie dort erscheinen.',
  pinnedApps: 'Angeheftete Apps',
  pinnedAppsEmpty: 'Ziehen Sie Apps hierher, um sie anzuheften.',
  availableApps: 'Verfügbare Apps',
  availableAppsEmpty: 'Alle verfügbaren Apps sind angeheftet. Ziehen Sie eine App hierher, um sie zu lösen.',
};
